import gql from 'graphql-tag';

import type { LongFormFeedAsset } from 'src/data/project';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationResetLongFormAssetToOriginalArgs } from 'src/types/backend';

import { FRAGMENT_LONG_FORM_ASSET_FULL } from './schema';

const MUTATION = gql`
  mutation ResetLongFormAssetToOriginal($longFormAssetId: ID!) {
    resetLongFormAssetToOriginal(longFormAssetId: $longFormAssetId) {
      ...LongFormAssetFull
    }
  }
  ${FRAGMENT_LONG_FORM_ASSET_FULL}
`;

type Variables = BackendMutationResetLongFormAssetToOriginalArgs;

/**
 * Puts an improved asset back to the text it was improved from, keeping the link so it can be
 * improved again. It comes back without the markup it carried, having nothing left to mark.
 */
export const resetLongFormAssetToOriginal = async (
  variables: Variables
): Promise<LongFormFeedAsset | undefined> => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<LongFormFeedAsset>(response.data);
};
